// 待提交日报
const basePath = "/admin/daily/";
export default [
    //未提交日報
    {
        path: `${basePath}await`,
        name: 'dailyList',
        component: r => require.ensure([], () => r(require('@/views/awaitDaily/dailyList')), 'awaitDaily')
    },
    {
        path: `${basePath}my`, //我的日报
        name: 'myDailyList',
        component: r => require.ensure([], () => r(require('@/views/awaitDaily/myDailyList')), 'awaitDaily')
    },

]
